import { render } from "./DeleteDnsZone.vue?vue&type=template&id=cbb913e4&scoped=true"
import script from "./DeleteDnsZone.vue?vue&type=script&lang=js"
export * from "./DeleteDnsZone.vue?vue&type=script&lang=js"

import "./DeleteDnsZone.vue?vue&type=style&index=0&id=cbb913e4&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbb913e4"]])

export default __exports__